export enum CampaignColumnIds {
  PAID_BY = 'paidBy',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  CAMPAIGN_TYPE = 'campaignType',
  CAMPAIGN_STATUS = 'status',
  SPEND = 'totalSpend',
  CAMPAIGN_ACTIONS = 'campaign_actions',
  ORDERS = 'totalOrders',
  SALES = 'totalSales',
  BUDGET = 'budget',
  VENUE = 'venue',
}
